export const tabMenu = () => {
  document.querySelectorAll(".js-tabmenu").forEach((container) => {
    const tabs = container.querySelectorAll('[role="tab"]');
    const tabpanels = container.querySelectorAll('[role="tabpanel"]');

    if (tabs.length === 0 || tabpanels.length === 0) return;

    // 初期化: 全タブを非選択状態にし、最初のタブのみ選択
    tabs.forEach((tab, i) => {
      tab.setAttribute("aria-selected", i === 0 ? "true" : "false");
      tab.setAttribute("tabindex", i === 0 ? "0" : "-1");
    });
    tabpanels.forEach((panel, i) => {
      panel.hidden = i !== 0;
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.getAttribute("aria-selected") === "true") return;

        const id = this.getAttribute("aria-controls");
        const panel = document.querySelector("#" + id);

        tabpanels.forEach((p) => {
          p.hidden = true;
        });

        panel.hidden = false;

        tabs.forEach((t) => {
          t.setAttribute("aria-selected", "false");
          t.setAttribute("tabindex", "-1");
        });

        this.setAttribute("aria-selected", "true");
        this.setAttribute("tabindex", "0");
        this.focus();
      });

      tab.addEventListener("keydown", function (e) {
        const index = [...tabs].indexOf(this);
        let target;

        if (e.key === "ArrowLeft") {
          target = index - 1;
        } else if (e.key === "ArrowRight") {
          target = index + 1;
        } else if (e.key === "End") {
          target = tabs.length - 1;
        } else if (e.key === "Home") {
          target = 0;
        } else {
          return;
        }

        e.preventDefault();

        if (target < 0) {
          target = tabs.length - 1;
        } else if (target >= tabs.length) {
          target = 0;
        }

        tabs[target].click();
      });
    });
  });
};
